<template>
  <div class="about DivImage" :style="{background: 'url('+ backgroungImg +') no-repeat'}">
    <img src="../assets/image/logo-dark.jpeg" alt="logo" class="logo-dark">
    <info-header :type="'3'"></info-header>
    <div class="infoGroup">
      <!-- <div class="title">ABOUT</div>
      <div >
        FTG is the top quality Architectural 3D computer graphics studio based in Hong Kong, formed for the industry of architectural and real estate development. Strict production workflow and project management system are structured only according to the necessity and distinguishing feature of the industry. High-Quality and Delivery-on-Time are our core philosophy. More than 50 architecutral design or computer graphics studies background artists form the team. Extremely selective recruitment is to garantee the quality and professionalism. We provide our services to professional clients in different continents, including: Urban Planning Departments, Properties Develipers, Master-Planners and Architects.
        <br><br>
        We specialize in producing 3D graphics for developments projects of:
        <br><br>
        <p>High Definition animation output with extremely strong rendering power</p>
        <p>Large scale master-planning and developments</p>
        <p>Complicated master-planning and architectural design</p>
        <p>Incomplete-design with our design input and assistance from our experience and databse</p>
        <p>Restricted production time</p>
        <p>24x7 service all the year</p>
      </div> -->
      <div id="Editor"></div>
    </div>
    <info-footer :dark="true" :isStatic="true"></info-footer>
  </div>
</template>

<script>
import InfoHeader from '../components/infoHeader.vue'
import InfoFooter from '../components/infoFooter.vue'
import BgDefault from '../assets/image/contact01.jpg'

import E from 'wangeditor'

export default {
  name: 'About',
  components: {
    InfoHeader, InfoFooter
  },
  // meta
  metaInfo: {
    title: 'FTG Studio - About',
    meta: [
      { name: 'description', content: 'Discover FTG Studio’s founding background, development journey and core positioning as a professional global architectural visualization studio. We focus on providing custom architectural rendering, CGI creation and design visualization outsourcing services for international architecture firms and design studios. This page introduces our service strengths, cross-regional collaboration experience, long-term global client partnerships and industry honors earned within the architectural visualization field.' }
    ]
  },
  data () {
    return {
      token: window.sessionStorage.getItem('token'),
      backgroungImg: '',
      backgroungImgArr: [],
      bgIndex: 0,
      timer: null,
      BgDefault: BgDefault
    }
  },
  methods: {
    
  },
  computed: {
    
  },
  mounted() {
    const that = this


    // 创建富文本编辑器
    that.editor = new E('#Editor');

    // 配置服务器端地址
    that.editor.customConfig.uploadImgServer = `${process.env.API_HOST}/upload/index.php`;
    // 将图片大小限制为 10M
    that.editor.customConfig.uploadImgMaxSize = 1024 * 1024 * 10;
    
    that.editor.customConfig.uploadFileName = 'imageFile';
    that.editor.customConfig.uploadImgHooks = {
      // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
      // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
      customInsert: function (insertImg, result, editor) {
        var url = result.pic;
        insertImg(url)
      }
    }
    that.editor.customConfig.customAlert = function (info) {
      // info 是需要提示的内容
      that.$Message.warning(info);
    }
    
    // 自定义菜单配置
    that.editor.customConfig.menus = [
      'head',  // 标题
      'bold',  // 粗体
      'fontSize',  // 字号
      'fontName',  // 字体
      'italic',  // 斜体
      'underline',  // 下划线
      'strikeThrough',  // 删除线
      'foreColor',  // 文字颜色
      'backColor',  // 背景颜色
      'link',  // 插入链接
      'list',  // 列表
      'justify',  // 对齐方式
      'quote',  // 引用
      'emoticon',  // 表情
      'image',  // 插入图片
      'table',  // 表格
      'code',  // 插入代码
      'undo',  // 撤销
      'redo'  // 重复
    ]

    that.editor.create();
    document.querySelector("#Editor .w-e-text").contentEditable = false;



    
  },
  created(){
    const that = this
    let Data = {
      // token: that.token
    }
    that.$api.getAboutInfo(Data).then(res => {
      if(res.rescode == 0){
        // http://149.129.49.179 -> https://cdn.ftgstudio.com
        let AboutInfo = res.about.replace(/https?:\/\/149\.129\.49\.179/g, 'https://cdn.ftgstudio.com')
        AboutInfo = AboutInfo.replace(/www.ftgstudio.com/g, 'cdn.ftgstudio.com')

        that.editor.txt.html(AboutInfo);

        that.backgroungImgArr = res.aboutUrl
        if(that.backgroungImgArr && that.backgroungImgArr.length > 0){
          that.backgroungImg = that.backgroungImgArr[that.bgIndex].url
        }else{
          // that.backgroungImg = that.BgDefault
        }

        that.timer = setInterval(function() {
          if(that.backgroungImgArr && that.backgroungImgArr.length > 0){
            that.backgroungImg = that.backgroungImgArr[that.bgIndex].url
            
            if(that.bgIndex == that.backgroungImgArr.length - 1){
              that.bgIndex = 0
            }else{
              that.bgIndex ++
            }
          }else{
            clearInterval(that.timer);
          }
        }, 10000);
      }
    }).catch(err => {});
  },
  beforeRouteLeave (to, from, next) {
    if(this.timer) { //如果定时器还在运行 或者直接关闭，不用判断
      clearInterval(this.timer); //关闭
    }
    next()
  }
}
</script>

<style scoped lang="less">
  @import '../assets/css/main.less';
</style>



// WEBPACK FOOTER //
// src/pages/about.vue